import React from 'react';
import Select from 'react-select'; // ✅ import react-select

const CourseDetails = ({ 
  formData, 
  onFormDataChange, 
  coursesData = {},
  courseFeesData = {},
  courseDurData = {},
}) => {

  const handleCourseTypeChange = (e) => {
    const selectedCourseType = e.target.value;
    onFormDataChange(prev => ({
      ...prev,
      courseType: selectedCourseType,
      courseName: '',
      courseFees: '',
      courseDuration: ''
    }));
  };

  const handleCourseChange = (selectedOption) => {
    const selectedCourse = selectedOption?.value || '';
    const courseDetails = courseFeesData[selectedCourse] || '';
    const courseDet = courseDurData[selectedCourse] || '';

    onFormDataChange(prev => ({
      ...prev,
      courseName: selectedCourse,
      courseFees: courseDetails,
      courseDuration: courseDet
    }));
  };

  // Prepare react-select options dynamically
  const courseOptions = formData.courseType
    ? coursesData[formData.courseType]?.map(course => ({
        value: course,
        label: course
      }))
    : [];

  return (
    <div className="form-section">
      <div className="section-content">
        <div className="form-row">
          {/* Course Type */}
          <div className="form-group">
            <label className="label">
              Course Type <span className="mandatory">*</span>
            </label>
            <select
              name="courseType"
              value={formData.courseType || ''}
              onChange={handleCourseTypeChange}
              required
              className="input select"
            >
              <option value="">Select Course Type</option>
              {Object.keys(coursesData).map((courseType) => (
                <option key={courseType} value={courseType}>
                  {courseType}
                </option>
              ))}
            </select>
          </div>

          {/* ✅ Course Name (React-Select Searchable Dropdown) */}
          <div className="form-group" style={{ minWidth: '250px',marginTop:'4px' }}>
            <label className="label">
              Course Name <span className="mandatory">*</span>
            </label>
            <Select
              options={courseOptions}
              value={
                formData.courseName
                  ? { value: formData.courseName, label: formData.courseName }
                  : null
              }
              onChange={handleCourseChange}
              placeholder="Search or select a course"
              isDisabled={!formData.courseType}
              isClearable
              classNamePrefix="react-select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#007bff' : '#ccc',
                  boxShadow: state.isFocused ? '0 0 0 1px #007bff' : 'none',
                  '&:hover': { borderColor: '#007bff' },
                  minHeight: '38px',
                  fontFamily: "'Times New Roman', Times, serif",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isFocused ? '#6a7178ff' : 'white',
                  color: state.isFocused ? 'white' : 'black',
                  fontFamily: "'Times New Roman', Times, serif",
                }),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
